import { ValueContainer } from "components/shared/select";
import React from "react";
import BaseTrailerTypeFilter from "./trailerType";

const MultiTrailerTypeFilter = (props) => {
    const selectProps = {
        inputProps: { name: "trailerTypeIds" },
        value: props.values.trailerTypeIds,
        components: { ValueContainer },
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        isMulti: true,
    };
    return <BaseTrailerTypeFilter {...props} selectProps={selectProps} />;
};

export default MultiTrailerTypeFilter;
